import React from "react";
import { Select } from "antd";
import PropTypes from "prop-types";
import Tag from "./Tag";
import _ from "lodash";
class Filter extends React.Component {
  state = { searchValue: "" };

  onChange = values => {
    return this.props.addFilter(values);
  };

  /**
   * retreive selected values
   * @return {Array}
   */
  getSelectedValues(items = []) {
    const { filterIdKey = "", filterLabelKey = "", filters = [] } = this.props;

    const values = [];
    if (!filterIdKey || !filterLabelKey) {
      return items;
    }

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const value = _.find(filters, { [filterIdKey]: item });
      if (value && value[filterLabelKey]) {
        values.push(value[filterLabelKey]);
      }
    }

    return values;
  }

  render() {
    const Option = Select.Option;
    const { placeholder, defaultValue, deps } = this.props;
    const maxLength = this.props.maxItemsToDisplay ? this.props.maxItemsToDisplay : 20;
    const children = [];
    const filters =
      (this.props.filters &&
        this.props.filters.sort((a, b) => {
          a = "" + a;
          b = "" + b;
          if (a.toLowerCase() < b.toLowerCase()) return -1;
          if (a.toLowerCase() > b.toLowerCase()) return 1;
          return 0;
        })) ||
      [];

    let i = 0;
    while (i < filters.length && children.length < maxLength) {
      const filter = filters[i];

      if (!filter) break;

      if (!filter.dep || deps.length === 0 || (filter.dep && deps.length > 0 && deps.indexOf(filter.dep) !== -1)) {
        if (
          filter.indexOf(this.state.searchValue.toUpperCase()) !== -1 ||
          filter.toUpperCase().indexOf(this.state.searchValue.toUpperCase()) !== -1 ||
          (this.props.currentFilters && this.props.currentFilters.indexOf(filter) !== -1)
        ) {
          children.push(
            <Option value={filter} key={filter || ""}>
              {filter}
            </Option>
          );
        }
      }

      i++;
    }

    return (
      <Select
        filterOption={(input, option) => {
          return typeof option.props.children === "string"
            ? option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            : false;
        }}
        onFocus={() => {
          this.setState(
            {
              searchValue: ""
            },
            this.props.setKeyFilterSelected
          );
        }}
        onSearch={value => {
          this.setState({
            searchValue: value
          });
        }}
        mode={this.props.mode ? this.props.mode : "multiple"}
        style={{ width: "100%" }}
        placeholder={placeholder}
        //defaultValue={defaultValue}
        value={defaultValue}
        onChange={v => {
          this.onChange(v);
        }}
        maxTagCount={0}
        maxTagPlaceholder={(items = []) => {
          const values = items;

          return <Tag items={values} label={placeholder} />;
        }}
        notFoundContent={"Aucune donnée"}
        allowClear={this.props.allowClear}
        showArrow={false}
        // showSearch={true}
      >
        {children}
      </Select>
    );
  }
}

Filter.propTypes = {
  filterTargetKey: PropTypes.string,
  // filters: PropTypes.array.isRequired,
  placeholder: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  depKey: PropTypes.string
};

export default Filter;



// WEBPACK FOOTER //
// src/components/filter/FilterPlanning.js